import _ from 'lodash';

import { COMMON_DATE_FORMAT } from 'constants/date';
import {
  accountingFormatOptions,
  fixedTwoFractionDigitsCurrencyOptions,
} from 'constants/loanApplication';
import { formatDate } from 'utils/date';
import { formatNumberToCurrencyString } from 'utils/number';

const currencyFormatOptions = {
  ...fixedTwoFractionDigitsCurrencyOptions,
  ...accountingFormatOptions,
};

export const formatCurrency = value => {
  if (_.isNil(value)) {
    return '-';
  }

  return formatNumberToCurrencyString(value, currencyFormatOptions);
};

export const formatDateValue = value => {
  if (!value) {
    return '-';
  }

  return formatDate(value, COMMON_DATE_FORMAT);
};

export const buildInteractionPayload = form => ({
  interactionDate: form.interactionDate,
  interactionType: form.interactionType?.value,
  subject: form.subject,
  description: form.description,
  contactName: form.contactName || null,
  contactPhone: form.contactPhone || null,
  contactEmail: form.contactEmail || null,
  resolution: form.resolution || null,
  followUpDate: form.followUpDate || null,
  followUpCompleted: !!form.followUpCompleted,
});

export const buildPaymentPayload = form => ({
  paymentDate: form.paymentDate,
  effectiveDate: form.effectiveDate,
  dueDate: form.dueDate,
  totalAmount: Number(form.totalAmount) || 0,
  principalAmount: Number(form.principalAmount) || 0,
  interestAmount: Number(form.interestAmount) || 0,
  escrowAmount: Number(form.escrowAmount) || 0,
  lateFeeAmount: Number(form.lateFeeAmount) || 0,
  otherAmount: Number(form.otherAmount) || 0,
  suspenseAmount: Number(form.suspenseAmount) || 0,
  paymentMethod: form.paymentMethod?.value ?? form.paymentMethod,
  paymentStatus: form.paymentStatus?.value ?? form.paymentStatus,
  referenceNumber: form.referenceNumber || null,
  notes: form.notes || null,
});

export const buildDisbursementPayload = form => ({
  disbursementDate: form.disbursementDate,
  disbursementType: form.disbursementType?.value,
  payeeName: form.payeeName,
  amount: Number(form.amount),
  referenceNumber: form.referenceNumber || null,
  notes: form.notes || null,
});

export const buildDrawRequestPayload = form => ({
  requestedAmount: Number(form.requestedAmount),
  notes: form.notes || null,
});
